<template>
  <q-table
    :columns="columns"
    :rows="filteredUsers"
    selection="multiple"
    :selected="selected"
    :selected-rows-label="selectedLabel"
    :loading="isLoading"
    :rows-per-page-options="[0]"
    flat
    @update:selected="$emit('update:selected', $event)"
  >
    <template v-slot:no-data>
      <message v-show="!isLoading" class="full-width">
        Client is assigned to every user.
      </message>
    </template>
  </q-table>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import Message from '@/components/message/Message.vue';
import { User } from '@/type';
import { HasTaskMixin } from '@/mixins';
import { filter } from '@/user/user';
import clientUserRepository from './clientUserRepository';

interface Data {
  task: Promise<User[]>|null,
  columns: object[],
  users: User[],
}

export default defineComponent({
  emits: ['update:selected'],
  components: { Message },
  mixins: [HasTaskMixin],
  props: {
    clientId: {
      type: Number,
      required: true,
    },
    selected: {
      type: Array as () => User[],
      default() {
        return [];
      },
    },
    keyword: String,
  },
  data(): Data {
    return {
      task: null,
      columns: [
        {
          name: 'name',
          label: 'Name',
          field: (u: User) => `${u.firstName} ${u.lastName}`,
          align: 'left',
        },
        {
          name: 'email',
          label: 'E-mail',
          field: (u: User) => u.email,
          align: 'left',
        },
      ],
      users: [],
    };
  },
  watch: {
    clientId: {
      handler() {
        this.load();
      },
      immediate: true,
    },
  },
  computed: {
    filteredUsers(): User[] {
      return filter(this.keyword || null, this.users);
    },
  },
  methods: {
    selectedLabel(): string {
      const count = this.selected.length;
      const total = this.users.length;
      return `${count} user${(count === 1) ? '' : 's'} selected of ${total}`;
    },
    load() {
      this.task = clientUserRepository.findUnassigned(this.clientId);
      this.task.then((users: User[]) => {
        this.users = users;
      });
    },
    removeItem(user: User) {
      const index = this.users.findIndex(uc => uc.id === user.id);
      if (index >= 0) {
        this.users.splice(index, 1);
      }
    },
  },
});
</script>
